import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=46b1060e&scoped=true"
import script from "./EditPage.vue?vue&type=script&lang=js"
export * from "./EditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1060e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b1060e')) {
      api.createRecord('46b1060e', component.options)
    } else {
      api.reload('46b1060e', component.options)
    }
    module.hot.accept("./EditPage.vue?vue&type=template&id=46b1060e&scoped=true", function () {
      api.rerender('46b1060e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/pages/EditPage.vue"
export default component.exports